import {configureStore} from "scholastic-client-components/src/SharedPackages/reduxToolkit"
import {rootReducer} from "./rootReducer"
import {formErrorMiddleware} from "scholastic-client-components/src/middlewares/formErrorMiddleware"

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => [
        ...getDefaultMiddleware(),
        formErrorMiddleware.middleware,
    ],
})